"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserAction = exports.Name = void 0;
const Name = exports.Name = 'video-play';
const UserAction = exports.UserAction = Name;
